<!-- 数据字典 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm">
            <!-- <el-form
                ref="form"
                :inline="true"
                :model="form"
                label-width="80px">
                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-puls"
                        @click="handleSearch"
                    >增加</el-button>
                </el-form-item>
            </el-form> -->
        </div>
        <lb-table v-loading="loading"
            :column="tableData.column"
            :data="tableData.data"
            :height="maxHeight"
            stripe
            pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="page_num"
            :total="total"
            :page-size="page_sum"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
        </lb-table>

        <!-- 新增+编辑弹框 -->
        <el-dialog :title="title" width="30%" :visible.sync="dialogFormVisible">
            <el-form :model="addForm" :rules="addFormRule" ref="addForm">
                <el-form-item label="配置名称" prop="dict_name">
                    <el-input v-model="addForm.dict_name" autocomplete="off" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="配置值" prop="dict_value">
                    <el-input v-model="addForm.dict_value" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSave">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<!--                            <el-dropdown size="mini" style="margin-left:15px;width:30%">
                                <el-button size="mini" type="primary">
                                    状态<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <div onClick={ () => { this.handleEditIsfixed(scope.row, 1) } }>可变</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div onClick={ () => { this.handleEditIsfixed(scope.row, 0) } }>不可变</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
<script>
import Service from '@/api/Service'
import LbTable from '@/components/lb-table/lb-table'
import { getMaxHeigth, $Alert } from '@/utils/utils'

export default {
    name:  'dictionary',
    data() {
        return {
            form: {},
            tableData: {
                column: [
                    {
                        type: 'index',
                        align: 'center'
                    },
                    {
                        prop: 'dict_code',
                        label: '配置编码',
                    },
                    {
                        prop: 'dict_name',
                        label: '配置名称',
                    },
                    {
                        prop: 'dict_value',
                        label: '值',
                    },
                    {
                        prop: 'isfixed',
                        label: '是否可变',
                        render: (h, scope) => {
                            return (
                                <el-tag type={scope.row.isfixed === 0 ? 'danger' : 'success'} effect="dark" size="medium" >{ scope.row.isfixed === 0 ? '不可变' : '可变' }</el-tag>
                            )
                        }
                    },
                    {
                        prop: 'update_date',
                        label: '更新时间'
                    },
                    {
                        prop: 'create_date',
                        label: '创建时间'
                    },
                    {
                        label: '操作',
                        render: (h, scope) => {
                        return (
                            <div>
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                onClick={ () => { this.handleEdit(scope.$index, scope.row) } }>编辑</el-button>
                            </div>
                        )
                        }
                    }
                ],
                data: []
            },
            loading: false,
            maxHeight: 500,
            total: 0,
            page_num: 1,
            page_sum: 10,

            dialogFormVisible: false,
            title: '编辑',
            addForm: {
                dict_name: '',
                dict_value: '',
            },
            addFormRule: {
                dict_name: [
                    { required: true, message: '请输入配置名称', trigger: 'blur' }
                ],
                dict_value: [
                    { required: true, message: '请输入配置值', trigger: 'blur' }
                ],
            }
        };
    },

    components: { LbTable },
    mounted() {
        this.$nextTick(()=>{
            this.maxHeight = getMaxHeigth();
        })
    },

    computed: {},

    created() {
        this.getData()
    },

    methods: {
        async getData() {
            let { page_num, page_sum } = this
            let params = Object.assign({}, this.form, { page_num, page_sum })
            let res = await Service.getBaseDictionary(params)
            if(res && res.list.length>0) {
                this.tableData.data = res.list
                this.total = res.total
            }
        },
        handleSave() {
            this.$refs['addForm'].validate(async (valid) => {
                if (valid) {
                    let res = await Service.editBaseDictionary(this.addForm)
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '修改成功!'
                        });
                        this.dialogFormVisible = false;
                        this.getData();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleEdit (index, row) {
            let { oid, dict_name, dict_value } = row
            this.addForm = Object.assign({}, { oid, dict_name, dict_value });
            this.dialogFormVisible = true;
        },
        handleCommand(com) {
            console.log(com);
        },
        handleEditIsfixed (row, isfixed) {
            let { oid } = row
            let str = isfixed === 0 ? '不可修改' : '可修改'
            $Alert(`是否确认 ${row.dict_name} 状态变为 ${str} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.editIsfixedBaseDictionary({ oid, isfixed });
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                        this.getData();
                    }
                }
            });
        },
        //   获取数据
        handleSizeChange (val) {
            this.page_num = 1
            this.page_sum = val
            this.getData()
        },
        handleCurrentChange (val) {
            if(isNaN(val)) return
            if(val === null) return
            this.page_num = val
            this.getData()
        },
    }
}

</script>
<style lang='less' scoped>

</style>